import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get_profilesdata } from './api';

const initialState = {
  loading: false,
  peofile_list: []
};

const actions = {
  GET_PROFILELIST: 'GetProfiles/GET_PROFILELIST'
};

export const GetProfiles = createAsyncThunk(
  actions.GET_PROFILELIST,
  async (payload) => {
    const response = await get_profilesdata(payload);
    return response;
  }
);

export const GetProfilesSlice = createSlice({
  name: 'getprofiles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetProfiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetProfiles.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.peofile_list = data;
      })
      .addCase(GetProfiles.rejected, (state) => {
        state.loading = false;
      });
  }
});

export default GetProfilesSlice.reducer;
